import {
  Badge,
  Button,
  Card,
  Checkbox,
  Modal,
  Tooltip,
  Form as AntForm,
} from "antd";
import { Form, MainTable } from "components";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { EditOutlined, MailOutlined, PrinterOutlined } from "@ant-design/icons";
import { FaChalkboardUser, FaCheckToSlot, FaUserDoctor } from "react-icons/fa6";
import { AuthContext } from "contexts";
import { render } from "less";
import { FaEnvelope, FaPrint } from "react-icons/fa";
import { instance } from "utils/axios";
import reportFields from "./reportFields";
import { useNavigate } from "react-router-dom";

const getStatusTagColor = (type) => {
  switch (type) {
    case 0:
      return "orange";

    case 1:
      return "success";
  }
};

const { confirm } = Modal;

function BookingDetail({ data, rowData, refreshData }) {
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [selectedData, setSelectedData] = useState(null);

  const { state, action } = useContext(AuthContext);
  const [reportForm] = AntForm.useForm();
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {}, []);

  const handleOK = (row, e) => {
    e.stopPropagation();
    modal.confirm({
      title: "Та төлөв өөрчлөхдөө итгэлтэй байна уу?",
      // content: <span>Та төлөв өөрчлөхдөө итгэлтэй байна уу?</span>,
      okText: "Тийм",
      cancelText: "Үгүй",
      onOk() {
        return new Promise((resolve, reject) => {
          instance({
            method: "post",
            url: `bookingservice/technical/${row.id}`,
          })
            .then((res) => {
              refreshData(data);
            })
            .catch((err) => {})
            .then(() => setLoading(false));
        }).catch(() => {});
      },
      onCancel() {},
    });
  };

  // const handleOK = (row) => {
  //   setLoading(true)
  //   instance({
  //     method: 'post',
  //     url: `bookingservice/technical/${row.id}`,
  //   }).then((res) => {
  //     refreshData(data)
  //   }).catch((err) => {

  //   }).then(() => setLoading(false))
  // }

  const handleDocPrint = (row) => {
    window.open(`/bookingresult/${row.guid}`, "rel=noopener noreferrer");
  };

  const handleSendMail = (row) => {
    setActionLoading(true);
    instance({
      method: "get",
      url: `bookingservice/sendmail/${row.id}`,
    })
      .then((res) => {
        action.onSuccess("Амжилттай илгээлээ!");
      })
      .catch((err) => {})
      .then(() => setActionLoading(false));
  };

  const handleReport = (row) => {
    setSelectedData(row);
    if (row.doctorStatus === 0) {
      setEditData({
        response:
          '<p><strong>Өгүүлэмж</strong><span style="font-weight: 400;">: нуруу чилнэ, баруун хөлрүүгээ өвдөнө&nbsp;</span></p>\n<p><span style="font-weight: 400;"><strong>Шинжилгээнд</strong>: ​анх удаа ​&nbsp;</span></p>\n<p><span style="font-weight: 400;"><strong>ДҮРСЛЭЛ:</strong></span></p>\n<p><strong>Ерөнхий үнэлгээ: </strong><span style="font-weight: 400;">&nbsp;</span></p>\n<p>&nbsp;</p>\n<p><span style="font-weight: 400;">Бүсэлхийн нуруунд хазайлт байгаа эсэх : </span><span style="font-weight: 400;">​</span><span style="font-weight: 400;">&nbsp;</span></p>\n<p><span style="font-weight: 400;">Нугас, нугасны суваг: </span></p>\n<p><span style="font-weight: 400;">Нугасны хөндийн эпидурал, субдурал, субарахнойд зайнууд:&nbsp; &nbsp;</span></p>\n<p><span style="font-weight: 400;">Фасет үе: </span><span style="font-weight: 400;">​</span><span style="font-weight: 400;">​</span><span style="font-weight: 400;">&nbsp;&nbsp;</span></p>\n<p><span style="font-weight: 400;">Ууц-сүүжний үе:&nbsp; &nbsp;</span></p>\n<p><strong>Нугалмайн их бие ба арын элементүүдийн үнэлгээ:</strong><span style="font-weight: 400;">&nbsp;</span></p>\n<p>&nbsp;</p>\n<p><span style="font-weight: 400;">Арын элементүүд: </span><span style="font-weight: 400;">​</span></p>\n<p><span style="font-weight: 400;">Төгсгөлийн ялтсууд:</span></p>\n<p><strong>Нугалам хоорондын жийргэвчийн&nbsp; үнэлгээ</strong><span style="font-weight: 400;">:&nbsp;&nbsp;</span></p>\n<p>&nbsp;</p>\n<p><strong>Th12-L1:</strong><span style="font-weight: 400;">&nbsp;</span></p>\n<p><strong>L1-L2, L2-L3:</strong><span style="font-weight: 400;">&nbsp;</span></p>\n<p><strong>L3-L4: </strong><span style="font-weight: 400;">​</span></p>\n<p><strong>L4-L5:&nbsp;</strong></p>\n<p><strong>L5-S1:&nbsp;</strong></p>',
      });
      setShowReportModal(true);
    } else {
      setEditData({
        response: row.response,
      });
      setShowReportModal(true);
    }
  };

  const renderButtons = (row) => {
    if (
      state?.userInfo?.profile.role === "Админ" ||
      state?.userInfo?.profile.role === "CEO" ||
      state?.userInfo?.profile.role === "Ресейпшн"
    ) {
      return (
        <div className="flex items-center gap-2">
          <Tooltip title="Хэвлэх">
            <Button
              size="small"
              disabled={!row.doctorStatus}
              onClick={() => handleDocPrint(row)}
              icon={<PrinterOutlined />}
            />
          </Tooltip>
        </div>
      );
    } else if (state?.userInfo?.profile.role === "Эмч") {
      return (
        <Tooltip title="Онош бичих">
          <Button
            size="small"
            onClick={() => handleReport(row)}
            disabled={!row.technicalStatus}
            icon={<EditOutlined />}
          />
        </Tooltip>
      );
    } else if (state?.userInfo?.profile.role === "Техникч") {
      return (
        <Tooltip title="Техникч зураг авч дууссан">
          <Button
            size="small"
            disabled={row.technicalStatus}
            onClick={(e) => handleOK(row, e)}
            loading={loading}
            icon={<FaCheckToSlot size={20} className="flex" />}
          />
        </Tooltip>
      );
    }
  };

  const columns = [
    {
      title: "Үйлчилгээ",
      dataIndex: "serviceName",
      key: "serviceName",
    },
    {
      title: "Эмч",
      dataIndex: "doctorName",
      key: "doctorName",
    },
    {
      title: "Техникч",
      dataIndex: "technicalName",
      key: "technicalName",
    },
    // {
    //   title: 'Үнэ',
    //   dataIndex: 'amount',
    //   key: 'amount',
    //   render: (text, row) => (
    //     <span>{Intl.NumberFormat().format(text)}</span>
    //   )
    // },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      width: 80,
      render: (text, row) => renderButtons(row),
    },
  ];

  const submitReport = (values) => {

    setActionLoading(true);
    instance({
      method: "post",
      url: `bookingservice/doctor/${selectedData.id}`,
      data: {
        response: values.response?.level?.content,
      },
    })
      .then((res) => {
        refreshData(data);
      })
      .catch((err) => {})
      .then(() => setActionLoading(false));
  };

  const handleCloseModal = () => {
    setShowReportModal(false);
    reportForm.resetFields();
  };

  const handleComplete = () => {
    setActionLoading(true);
    instance({
      method: "put",
      url: `customerbooking/${rowData.id}`,
    })
      .then((res) => {
        refreshData(data);
      })
      .catch((err) => {})
      .then(() => setActionLoading(false));
  };

  return (
    <Badge.Ribbon
      text={rowData?.status == 1 ? "Хариу гарсан" : "Хариу гараагүй"}
      color={getStatusTagColor(rowData?.status)}
    >
      <Card>
        <div className="text-lg mb-3">Үйлчлүүлэгчийн мэдээлэл</div>
        <div className="flex flex-col mb-2 text-xs gap-1">
          <div className="flex items-center gap-2">
            <div className="text-gray-400">Овог нэр:</div>
            <div>
              {rowData?.customerLastname} {rowData?.customerFirstname}
            </div>
          </div>
          <div className="flex gap-5">
            <div className="flex items-center gap-2">
              <div className="text-gray-400">Нас:</div>
              <div>{data?.age ? data?.age : ""}</div>
            </div>
            <div className="flex items-center gap-2">
              <div className="text-gray-400">Хүйс:</div>
              <div>
                {data?.customerGender && data?.customerGender === 1
                  ? "Эр"
                  : "Эм"}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-gray-400">Хариу авах утас:</div>
            <div>{data?.answerPhone}</div>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-gray-400">Хариу авах и-мэйл:</div>
            <div>{data?.answerMail}</div>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-gray-400">Харшилтай эсэх:</div>
            <div>{data?.customerHasAllergy === 1 ? "Тийм" : "Үгүй"}</div>
          </div>
          {data?.customerHasAllergy === 1 ? (
            <div className="flex items-center gap-2">
              <div className="text-gray-400">Харшил:</div>
              <div>{data?.CustomerAllergyDescr}</div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="mb-2 text-xs">
          <div>Зовиур:</div>
          <div className="border rounded px-4 py-2 bg-gray-100">
            {data?.painful}
          </div>
        </div>
        <div className="flex items-center gap-2 mb-5 text-xs">
          <div className="text-gray-400">Илгээсэн эмч, эмнэлэг:</div>
          <div>{data?.fromDescr}</div>
        </div>
        {/* <div className="text-lg mb-3">Мөнгөн дүн</div> */}
        <div className="flex flex-col mb-6 text-xs gap-1">
          <div className="flex items-center gap-2">
            <div className="text-gray-400">И-Баримт:</div>
            <div>{data?.ebarimtStatus === 1 ? "Тийм" : "Үгүй"}</div>
          </div>
          <div className="flex items-center gap-2">
            {/* <div className="text-gray-400">Нийт мөнгөн дүн:</div>
            <div>{Intl.NumberFormat().format(data?.amount)} ₮</div> */}
          </div>
          <div className="flex items-center gap-2">
            <div className="text-gray-400">CD:</div>
            <div>{data?.cd}</div>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-gray-400">Төхөөрөмж:</div>
            <div>{data?.serviceTypeName}</div>
          </div>
        </div>
        <MainTable
          columns={columns}
          dataTable={data?.bookingservices}
          title={<div className="text-base">Авсан үйлчилгээ</div>}
        />
        <div className="flex flex-col items-end mt-6 text-xs">
          <div className="flex items-center gap-2">
            <div className="text-gray-400">Бүртгэсэн ажилтан:</div>
            <div>{data?.technicalUser}</div>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-gray-400">Бүртгэсэн огноо:</div>
            <div>{moment(data?.createdAt).format("YYYY-MM-DD HH:mm")}</div>
          </div>
        </div>
      </Card>
      {rowData.status === "Finished" && (
        <div className="mt-5 flex justify-end">
          <Button type="primary" onClick={handleComplete} loading={loading}>
            Complete
          </Button>
        </div>
      )}
      <Modal
        title={"Эмчийн дүгнэлт"}
        open={showReportModal}
        destroyOnClose
        width={800}
        okText="Хадгалах"
        centered
        confirmLoading={actionLoading}
        onOk={reportForm.submit}
        onCancel={actionLoading ? null : handleCloseModal}
        cancelButtonProps={{ disabled: actionLoading }}
      >
        {showReportModal ? (
          <Form
            form={reportForm}
            fields={reportFields}
            layout="vertical"
            onFinish={submitReport}
            editData={editData}
            // isEdit={isEdit}
            className="gap-4"
          />
        ) : null}
      </Modal>
      {contextHolder}
    </Badge.Ribbon>
  );
}

export default BookingDetail;
